import { Dispatch, RootState } from 'store';
import { createSelector } from 'reselect';
import { getQaCookies, getLang } from 'utils';
import { createFeatureSelector } from 'common/create-feature-selector';
import { getEnv } from 'common/selectors/env';
import { FetchStoreDetailProps } from 'features/store/types';
import { GetStoreByIdParams } from './api';
import { fetchStoreByIdThunk } from './store-by-id-slice';

export const rootSelector = createFeatureSelector('storeDetail');
export const getStoreDetail = createSelector(rootSelector, (s) => s.data);
export const getImageLink = createSelector(getStoreDetail, (s) => s?.imageLink);
export const getPlankLink = createSelector(getStoreDetail, (s) => s?.planLink);
export const getStoreErrorCode = createSelector(rootSelector, (s) => s.errorCode);
export const getCompanyId = createSelector(getStoreDetail, (s) => s?.companyId);
export const getStoreServices = createSelector(getStoreDetail, (s) => s?.services);
export const getStoreFeatures = createSelector(getStoreDetail, (s) => s?.features);
export const getStoreProjectsCenters = createSelector(getStoreDetail, (s) => s?.projects);
export const getIsPickupPoint = createSelector(getStoreDetail, (s) => s?.isPickupPoint);
export const getGardenCenterOperationalTime = createSelector(
  getStoreDetail,
  (s) => s?.gardenCenterOperationalTime,
);
export const getBuildingYardOperationalTime = createSelector(
  getStoreDetail,
  (s) => s?.buildingYardOperationalTime,
);

export const fetchStoreDetail = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const state = getState();
  const qaCookie = getQaCookies(state.cookie);
  const lang = getLang();
  const pathname = state.router?.path;
  const matchedStoreName = pathname?.match(/\/shop\/([^\\/]*)/);
  const storeName = matchedStoreName && matchedStoreName.length > 1 ? matchedStoreName[1] : '';
  const { ORCHESTRATOR_HOST, API_KEY } = getEnv(state);
  const params: FetchStoreDetailProps = {
    storeName,
    lang,
  };
  const options: GetStoreByIdParams = {
    host: ORCHESTRATOR_HOST,
    params,
    config: {
      headers: {
        'x-api-key': API_KEY,
      },
    },
  };

  if (qaCookie) {
    options.config = { ...options.config, headers: { ...options.config?.headers, cookie: qaCookie } };
  }

  return dispatch(fetchStoreByIdThunk(options));
};
